import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewDropAllocationAction {
  public static readonly type = '[AllocationViewDropAllocationAction] Allocation Drop';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewDropAllocationActionSetInitialState {
  public static readonly type = '[AllocationViewDropAllocationAction] Set Initial State';
}
